module.exports = __webpack_public_path__ + "static/media/bradesco.8e1be143.svg";